import React, { Component } from "react";
import { fire, auth } from "../../../firebase/index";
import LocalizedStrings from "react-localization";

let localizationStrings = new LocalizedStrings({
  en: {
    reply1:
      "Unlike many conventional combination digit-wheel dial locks that can be cracked in seconds, eGeeTouch® NFC+Bluetooth smart luggage locks are preprogramed with patented algorithm having 6-alphanumeric codes containing over many millions of IDs. The preprogramed ID is further encrypted to enhance proximity access NFC security. A proprietary communication protocol is further deployed for multiple security layers preventing unauthorized attempts to extract stored information. User defined unlocking IDs can be conveniently set by authorized lock's owner and securely stored on your Android &/or iOS smartphone or tablet using eGeeTouch App, or PC without the need to remember codes. This security protocol is similar to those online banking or retailer's point-of-sales payment but simpler to use. For more info on Innovation Awards, ",
    reply2: "click here",
    back: "Back",
  },
  ja: {
    reply1:
      "数秒で解読できる多くの従来の組み合わせの数字ホイール ダイヤル ロックとは異なり、eGeeTouch® NFC+Bluetooth スマート ラゲッジ ロックは、数百万を超える ID を含む 6 桁の英数字コードを持つ特許取得済みのアルゴリズムで事前にプログラムされています。事前にプログラムされた ID はさらに暗号化され、近接アクセス NFC のセキュリティが強化されます。さらに、複数のセキュリティ層に独自の通信プロトコルが導入されており、保存されている情報を不正に抽出しようとする試みを防止します。ユーザー定義のロック解除 ID は、認可されたロックの所有者によって簡単に設定でき、コードを覚える必要がなく、eGeeTouch アプリまたは PC を使用して Android および/または iOS のスマートフォンやタブレットに安全に保存できます。このセキュリティ プロトコルは、オンライン バンキングや小売店の POS 支払いに似ていますが、より簡単に使用できます。イノベーションアワードの詳細については、",
    reply2: "ここをクリック",
    back: "戻る",
  },
  es: {
    reply1:
      "A diferencia de muchas candados de combinación convencionales con dial de dígitos que se pueden abrir en segundos, las candados de equipaje inteligentes eGeeTouch® NFC+Bluetooth están preprogramadas con un algoritmo patentado que tiene códigos de 6 alfanuméricos que contienen más de muchos millones de identificaciones. La identificación preprogramada se cifra aún más para mejorar la seguridad NFC del acceso de proximidad. Además, se implementa un protocolo de comunicación propietario para múltiples capas de seguridad que evitan intentos no autorizados de extraer información almacenada. El propietario autorizado de la candado puede configurar cómodamente las ID de desbloqueo definidas por el usuario y almacenarlas de forma segura en su teléfono inteligente o tableta Android o iOS mediante la aplicación eGeeTouch o en su PC sin necesidad de recordar códigos. Este protocolo de seguridad es similar a los de banca online o pago en punto de venta de minoristas pero más sencillo de utilizar. Para obtener más información sobre los premios a la innovación, ",
    reply2: "haga clic aquí",
    back: "Atrás",
  },
});

class Q3_component extends Component {
  constructor(props) {
    super(props);

    this.state = {
      triggerValue: "0",
      clicked: false,
      language: "en",
    };
  }

  componentDidMount() {
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          localizationStrings.setLanguage(snapshot.val());
          this.setState({ language: snapshot.val() });
        });
    }
  }

  handleButtonClick2 = () => {
    if (!this.state.clicked) {
      this.setState({ triggerValue: "cancel", clicked: true }, () => {
        this.props.triggerNextStep({
          value: "cancel",
          trigger: "cancel",
        });
      });
    }
  };

  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    const buttonStyle = {
      marginTop: "10px",
      width: "215px",
      backgroundColor: "#FFC500",
      color: "black",
      borderRadius: "25px",
      textAlign: "center",
      padding: "10px 10px",
      cursor: "pointer",
      transition: "background-color 0.3s",
      border: "none",
    };

    const buttonHoverStyle = {
      color: "white",
      backgroundColor: "#EF6C00",
    };

    const { triggerValue, clicked } = this.state;

    return (
      <div>
        {localizationStrings.reply1}
        <a
          href="http://www.egeetouch.com/about/award"
          target="_blank"
          style={{ textDecoration: "underline", color: "black" }}
        >
          {localizationStrings.reply2}
        </a>
        {this.state.language === "ja" ? "。" : "."}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            margin: "12px 0",
          }}
        >
          <button
            style={{
              ...buttonStyle,
              ...(triggerValue === "cancel" && buttonHoverStyle),
            }}
            onMouseEnter={() => this.setState({ isButtonHovered: true })}
            onMouseLeave={() => this.setState({ isButtonHovered: false })}
            onClick={this.handleButtonClick2}
            disabled={clicked}
          >
            {localizationStrings.back}
          </button>
        </div>
      </div>
    );
  }
}

export default Q3_component;
